var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base_template"},[_c('Topnav'),_vm._t("default"),_c('Footer',{scopedSlots:_vm._u([{key:"faq",fn:function(){return [_vm._t("faq")]},proxy:true}],true)}),(!_vm.hidehelp)?_c('HowItWorks'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }